<app-container type="dark" title="Lender details">
	<app-client-search
		label="Full name"
		name="privateLenderName"
		[value]="_mortgagee?.privateLender?.fullName"
		(clientSelected)="SetPrivateLender($event)"
		(add)="onAddPrivateLender($event)"
	></app-client-search>

	<app-input
		label="Lender's RE Line"
		[ngModel]="_mortgagee?.correspondence?.lenderRELine"
		(debounce)="setLenderReLine($event)"
		class="mt-2"
	></app-input>

	<div class="flex mt-2">
		<app-input
			label="Work phone"
			class="mr-2"
			[ngModel]="_mortgagee?.privateLender?.workPhone"
			(debounce)="SetPrivateLenderWorkPhone($event)"
		></app-input>
		<app-input
			label="Cell phone"
			class="ml-2"
			[ngModel]="_mortgagee?.privateLender?.phone"
			(debounce)="SetPrivateLenderPhone($event)"
		></app-input>
	</div>
	<div class="flex mt-2">
		<app-input
			label="Fax"
			class="mr-2"
			[ngModel]="_mortgagee?.privateLender?.fax"
			(debounce)="SetPrivateLenderFax($event)"
		></app-input>
		<app-input
			label="Email"
			class="ml-2"
			[ngModel]="_mortgagee?.privateLender?.email"
			(debounce)="SetPrivateLenderEmail($event)"
		></app-input>
	</div>

	<app-address
		name="Mailing address"
		[address]="_mortgagee?.privateLender?.address"
		(onAddressUpdate)="addressChanged($event)"
		[enableCountrySelect]="false"
		class="mt-2"
	>
	</app-address>

	<div class="flex justify-between mt-10">
		<h4>Correspondence</h4>
		<app-radio-group
			header
			type="compact"
			[items]="correspondenceOptions"
			[ngModel]="_mortgagee?.correspondenceType"
			(ngModelChange)="setCorrespondenceType($event)"
		></app-radio-group>
	</div>

	<div
		*ngIf="_mortgagee?.correspondenceType === correspondenceTypes.SOLICITOR"
		[@openClose]
		class="mt-3 mb-3"
	>
		<app-solicitor
			[solicitor]="_mortgagee?.solicitor"
			(onUpdate)="updateSolicitor($event)"
		></app-solicitor>
	</div>

	<div *ngIf="_mortgagee?.correspondenceType" [@openClose] class="mt-5">
		<h4 class="mt-3">
			{{ _mortgagee?.correspondenceType | capitalize }} banking details
		</h4>
		<app-input
			label="Bank"
			[ngModel]="_mortgagee?.privateLender?.banking?.bank"
			(debounce)="SetPrivateLenderBank($event)"
			class="mt-2"
		></app-input>

		<div class="mt-3 flex">
			<app-input
				label="Transit number"
				class="mr-2"
				[ngModel]="_mortgagee?.privateLender?.banking?.transitNumber"
				(debounce)="SetPrivateLenderTransitNumber($event)"
			></app-input>
			<app-input
				label="Institution number"
				class="mx-2"
				[ngModel]="_mortgagee?.privateLender?.banking?.institutionNumber"
				(debounce)="SetPrivateLenderInstitutionNumber($event)"
			></app-input>
			<app-input
				label="Account number"
				class="ml-2"
				[ngModel]="_mortgagee?.privateLender?.banking?.accountNumber"
				(debounce)="SetPrivateLenderAccountNumber($event)"
			></app-input>
		</div>
	</div>
</app-container>
